import AgeRangeDao from '../dao/age-ranges.dao';
import type { AgeRange, Environment } from '../interfaces';

export abstract class AgeRangeService {
  static async getAgeRange(env: Environment): Promise<AgeRange[]> {
    return await AgeRangeDao.getAgeRangeData(env);
  }
}
